import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { keyVault } from '@bingads-webui-react/popup-manager';
import { CalloutWithLock } from './callout-with-lock';

export const GridTooltip = (props) => {
  const { onClose, onMouseLeave, parentView } = props;

  useEffect(() => {
    if (parentView) {
      parentView.on('closePopup', onClose);
    }

    return () => {
      if (parentView) {
        parentView.off('closePopup');
      }
    };
  }, [onClose, parentView]);

  useEffect(() => {
    document.querySelector('.table-page-container')?.addEventListener('scroll.actionCallout', onClose);
    document.querySelector('.table-page-container .scrollbars-view')?.addEventListener('scroll.actionCallout', onClose);

    return () => {
      document.querySelector('.table-page-container')?.removeEventListener('scroll.actionCallout', onClose);
      document.querySelector('.table-page-container .scrollbars-view')?.removeEventListener('scroll.actionCallout', onClose);
    };
  }, [onClose]);

  return (
    <div onMouseLeave={onMouseLeave}>
      <CalloutWithLock
        lockKey={keyVault.hoveringPopup}
        {...props}
      />
    </div>);
};

GridTooltip.propTypes = {
  parentView: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
};

GridTooltip.defaultProps = {
  parentView: null,
};
